import React from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PlayersTableBody from "./PlayersTableBody";

const PlayersTable = ({ players, onMenuOpen }) => {
  return (
    <TableContainer>
      <Table sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Headshot
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                display: "flex",
                alignItems: "center",
                color: "#464A53",
              }}
            >
              <Box display="flex" alignItems="center">
                Name
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button size="small" sx={{ minWidth: 0, padding: 0 }}>
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button size="small" sx={{ minWidth: 0, padding: 0 }}>
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Nickname
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Sport
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              League
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Team
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Number
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Position
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Nationality
            </TableCell>
            <TableCell
              sx={{ backgroundColor: "transparent", borderBottom: "none" }}
            />
          </TableRow>
        </TableHead>
        <PlayersTableBody players={players} onMenuOpen={onMenuOpen} />
      </Table>
    </TableContainer>
  );
};

export default PlayersTable;
